import { ADICIONAR_FILTRO_CTE_OS } from '../types'

export default function adicionarFiltroCteOs (filtro) {
  return {
    type: ADICIONAR_FILTRO_CTE_OS,
    payload: filtro
  }
}
